import { useSearchHandlers } from '@domain-group/fe-co-allhomes-autocomplete';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { Filters, SearchQuery, resolveLocalities } from '@domain-group/fe-allhomes-search-api';
var useHeaderSearchHandlers = _ref => {
  var listingType = _ref.listingType,
    immediateTypes = _ref.immediateTypes,
    onRedirect = _ref.onRedirect;
  var _useAllhomesApi = useAllhomesApi(),
    localityLookup = _useAllhomesApi.localityLookup,
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl;
  var urlResolver = values => new Promise(resolve => {
    var query = new SearchQuery(listingType, new Filters(listingType).cloneWithLocalities(values));
    resolveLocalities(query, localityLookup).then(localityMap => query.resolveLocalities(localityMap)).then(() => resolve(getAbsoluteUrl(query.toSearchUrl()))).catch(() => {});
  });
  return useSearchHandlers({
    urlResolver,
    onRedirect,
    immediateTypes
  });
};
export default useHeaderSearchHandlers;